<template>
  <div class="PersonelConflictReport">
    <section-personel-search-panel :accessTo="50" @search="search" />

    <box class="mt-2" :title="$t('functionalityList')">
      <div v-if="list.length > 0">
        <personel-conflict-list-web :list="list" class="hidden-sm-and-down" />
        <personel-conflict-list-mob :list="list" class="hidden-md-and-up" />
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>
  </div>
</template>

<script>
import PersonelConflictListMob from "../../components/personelOperationReport/PersonelConflictList/PersonelConflictListMob.vue";
import PersonelConflictListWeb from "../../components/personelOperationReport/PersonelConflictList/PersonelConflictListWeb.vue";
import SectionPersonelSearchPanel from "../../components/personelOperationReport/SectionPersonelSearchPanel.vue";
import ResultType from "../../model/ResultType";
export default {
  components: {
    SectionPersonelSearchPanel,
    PersonelConflictListWeb,
    PersonelConflictListMob,
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    search(searchParams) {
      var params = {
        perno: searchParams.perno,
        begindate: searchParams.beginDate,
        enddate: searchParams.endDate,
      };
      this.$store.dispatch("GetPersonConflict", { params }).then((result) => {
          //console.log(result);
        if (result.type === ResultType.success) {
            this.list = result.data.Table
        }
        
      });
    },
  },
};
</script>

<style>
</style>